import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { PageHead, Modal, Field, inp } from "../../components/admin/AdminBits";
import { Plus, Pencil, Trash2, Star } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { name: "", city: "", rating: 5, text: "", product: "", approved: true };

export default function AdminReviews() {
  const [reviews, setReviews] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/reviews").then(({ data }) => setReviews(data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (edit.id) await api.put(`/admin/reviews/${edit.id}`, edit);
      else await api.post("/admin/reviews", edit);
      toast.success("Запазено"); setEdit(null); load();
    } catch { toast.error("Грешка"); }
  };
  const del = async (id) => { if (window.confirm("Изтриване?")) { await api.delete(`/admin/reviews/${id}`); load(); } };

  return (
    <div data-testid="admin-reviews">
      <PageHead title="Отзиви" desc="Отзивите се показват като слайдер на началната страница."
        action={<button onClick={() => setEdit({ ...EMPTY })} className="btn-gold px-4 py-2.5 rounded-sm text-sm flex items-center gap-2" data-testid="add-review-btn"><Plus size={16} /> Нов отзив</button>} />
      <div className="grid md:grid-cols-2 gap-5">
        {reviews.map((r) => (
          <div key={r.id} className="bg-white border border-stone p-5" data-testid={`review-${r.id}`}>
            <div className="flex items-center justify-between mb-2">
              <div className="flex gap-0.5 text-gold">{Array.from({ length: r.rating || 5 }).map((_, k) => <Star key={k} size={14} fill="#C6A45C" />)}</div>
              <div className="flex gap-2"><button onClick={() => setEdit(r)} className="text-navy hover:text-gold"><Pencil size={15} /></button><button onClick={() => del(r.id)} className="text-charcoal/40 hover:text-red-500"><Trash2 size={15} /></button></div>
            </div>
            <p className="text-navy">„{r.text}"</p>
            <p className="text-sm text-charcoal/50 mt-3">{r.name} · {r.city}</p>
          </div>
        ))}
      </div>
      {edit && (
        <Modal title={edit.id ? "Редакция на отзив" : "Нов отзив"} onClose={() => setEdit(null)}>
          <form onSubmit={save}>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Име"><input required value={edit.name} onChange={(e) => setEdit({ ...edit, name: e.target.value })} className={inp} data-testid="review-name" /></Field>
              <Field label="Град"><input value={edit.city} onChange={(e) => setEdit({ ...edit, city: e.target.value })} className={inp} /></Field>
            </div>
            <Field label="Рейтинг (1-5)"><input type="number" min="1" max="5" value={edit.rating} onChange={(e) => setEdit({ ...edit, rating: parseInt(e.target.value) || 5 })} className={inp} /></Field>
            <Field label="Текст"><textarea required value={edit.text} onChange={(e) => setEdit({ ...edit, text: e.target.value })} rows={3} className={inp} data-testid="review-text" /></Field>
            <Field label="Картина (по избор)"><input value={edit.product} onChange={(e) => setEdit({ ...edit, product: e.target.value })} className={inp} /></Field>
            <button type="submit" className="btn-gold w-full py-2.5 rounded-sm mt-2" data-testid="save-review-btn">Запази</button>
          </form>
        </Modal>
      )}
    </div>
  );
}
